import { action } from "typesafe-actions";
import { HallRoomActionTypes } from "./types";
import {
  CreateHallRoomPayload,
  DeleteHallRoomPayload,
  GetHallRoomPayload,
  GetHallRoomsPayload,
  HallRoom,
  UpdateHallRoomPayload,
} from "../../interfaces/HallRoom";
import { message } from "antd";

export const getHallRooms = (payload: GetHallRoomPayload) => {
  return action(HallRoomActionTypes.FETCH_ROOMS_REQUEST, payload);
};

export const getHallRoomsSuccess = (halls: HallRoom[]) => {
  return action(HallRoomActionTypes.FETCH_ROOMS_SUCCESS, halls);
};

export const getHallRoomsFailure = (error: any) => {
  return action(HallRoomActionTypes.FETCH_ROOMS_ERROR, error);
};

export const getHallRoomsByHall = (payload: string) => {
  return action(HallRoomActionTypes.FETCH_ROOMS_BY_HALL_REQUEST, payload);
};

export const getHallRoomsByHallSuccess = (rooms: HallRoom[]) => {
  return action(HallRoomActionTypes.FETCH_ROOMS_BY_HALL_SUCCESS, rooms);
};

export const getHallRoomsByHallFailure = (error: any) => {
  return action(HallRoomActionTypes.FETCH_ROOMS_BY_HALL_ERROR, error);
};

export const getHallRoom = (payload: GetHallRoomPayload) => {
  return action(HallRoomActionTypes.FETCH_ROOM_REQUEST, payload);
};

export const getHallRoomSuccess = (room: HallRoom) => {
  return action(HallRoomActionTypes.FETCH_ROOM_SUCCESS, room);
};

export const getHallRoomFailure = (error: any) => {
  message.error(error);
  return action(HallRoomActionTypes.FETCH_ROOM_ERROR, error);
};

export const createHallRoom = (payload: CreateHallRoomPayload) => {
  return action(HallRoomActionTypes.CREATE_ROOM_REQUEST, payload);
};

export const createHallRoomSuccess = (room: HallRoom) => {
  return action(HallRoomActionTypes.CREATE_ROOM_SUCCESS, room);
};

export const createHallRoomFailure = (error: any) => {
  return action(HallRoomActionTypes.CREATE_ROOM_ERROR, error);
};

export const updateHallRoom = (payload: UpdateHallRoomPayload) => {
  return action(HallRoomActionTypes.UPDATE_ROOM_REQUEST, payload);
};

export const updateHallRoomSuccess = (room: HallRoom) => {
  return action(HallRoomActionTypes.UPDATE_ROOM_SUCCESS, room);
};

export const updateHallRoomFailure = (error: any) => {
  return action(HallRoomActionTypes.UPDATE_ROOM_ERROR, error);
};

export const deleteHallRoom = (payload: DeleteHallRoomPayload) => {
  return action(HallRoomActionTypes.DELETE_ROOM_REQUEST, payload);
};

export const deleteHallRoomSuccess = (room: CreateHallRoomPayload) => {
  return action(HallRoomActionTypes.DELETE_ROOM_SUCCESS, room);
};

export const deleteHallRoomFailure = (error: any) => {
  return action(HallRoomActionTypes.DELETE_ROOM_ERROR, error);
};

export const clearRoomState = () => {
  return action(HallRoomActionTypes.CLEAR_ROOM_STATE);
};
